import classnames from "classnames";

interface LoaderProps {
  className?: string;
  text?: string;
}

export const Loader = ({className, text}: LoaderProps) => (
  <div className={classnames("spinner-border", `${className ? className : "text-muted"}`)} role="status">
    <span className="visually-hidden">{text ?? "Loading..."}</span>
  </div>
);
